import type { StateCreator } from "zustand";
import type { Store } from "../globalStore";

// FIXME: Almost everything in this file is context specific.
// We should move this to the component that uses the context
// and then import that context into the component that uses the store.
// This will make our lives easier since we don't have to worry about clearing the state.
export interface CompanionSlice {
  isFilterOpen: boolean;
  setIsFilterOpen: (newValue: boolean | ((value: boolean) => boolean)) => void;
  filterCount: number;
  setFilterCount: (newValue: number) => void;
  resetCompanion: () => void;
  isCreatingNewAppointment: boolean;
  setIsCreatingNewAppointment: (newValue: boolean) => void;
  isEditingExistingAppointment: boolean;
  setIsEditingExistingAppointment: (newValue: boolean) => void;
  isSchedulingBoughtTreatment: boolean;
  setIsSchedulingBoughtTreatment: (newValue: boolean) => void;
  isCollectingPayment: boolean;
  setIsCollectingPayment: (newValue: boolean) => void;
  isInsuranceModified: boolean;
  setIsInsuranceModified: (newValue: boolean) => void;
  // todo: get rid of this (or maybe use it) after global store refactor
  // OR TODO: RENAME THIS BETTER AS WE CAN USE THIS FLAG FOR ANY DOT ACTION
  isComingFromGlobalRoster: boolean;
  setIsComingFromGlobalRoster: (newValue: boolean) => void;
  isManagingIntake: boolean;
  setIsManagingIntake: (newValue: boolean) => void;
  isUserListMinimized: () => boolean;
  currentAppointmentId: string;
  setCurrentAppointmentID: (arg: string) => void;
  getFormHeader: () => string;
  closeFormModal: () => void;
  resolvingAppts: string[];
  setResolvingAppts: (newValue: string[]) => void;
}

export const companionInitialState = {
  isFilterOpen: false,
  filterCount: 0,
  isCreatingNewAppointment: false,
  isEditingExistingAppointment: false,
  isSchedulingBoughtTreatment: false,
  isCollectingPayment: false,
  isInsuranceModified: false,
  // todo: get rid of this after refactor to handle nav better
  isComingFromGlobalRoster: false,
  isManagingIntake: false,
  currentAppointmentId: "",
  resolvingAppts: [],
};

export const createCompanionSlice: StateCreator<
  Store,
  [["zustand/devtools", never], ["zustand/persist", unknown]],
  [],
  CompanionSlice
> = (set, get) => ({
  ...companionInitialState,
  setIsFilterOpen: (value) => {
    const newValue =
      typeof value === "function" ? value(get().isFilterOpen) : value;
    set({ isFilterOpen: newValue });
  },
  setFilterCount: (newValue) => set({ filterCount: newValue }),
  resetCompanion: () => set(companionInitialState),
  // TODO: use nuqs to use query params
  isUserListMinimized: () => {
    return (
      get().isCreatingNewAppointment ||
      get().isEditingExistingAppointment ||
      get().isSchedulingBoughtTreatment ||
      get().isCollectingPayment ||
      get().isManagingIntake
    );
  },
  setResolvingAppts: (arg: string[]) => {
    set({
      resolvingAppts: arg,
    });
  },
  closeFormModal: () => {
    set({
      isCreatingNewAppointment: false,
      isEditingExistingAppointment: false,
      isSchedulingBoughtTreatment: false,
      isComingFromGlobalRoster: false,
      isCollectingPayment: false,
      isManagingIntake: false,
      isInsuranceModified: false,
      globalDotRelatedAppointmentId: null,
      globalDotRelatedConsumerId: null,
    });
  },
  getFormHeader: () => {
    if (get().isCreatingNewAppointment) {
      return "Create Appointment";
    }
    if (get().isEditingExistingAppointment) {
      if (get().slots.some((slot) => slot.status === "canceled")) {
        return "Rescheduling cancelled appointment";
      }
      return "Edit Appointment";
    }
    if (get().isSchedulingBoughtTreatment) {
      return "Schedule Treatments";
    }
    if (get().isCollectingPayment) {
      return "Collect Payment";
    }
    if (get().isManagingIntake) {
      return "Handling Intake";
    }

    return "Form";
  },
  setIsInsuranceModified: (arg: boolean) => set({ isInsuranceModified: arg }),
  setIsCreatingNewAppointment: (arg: boolean) =>
    set({ isCreatingNewAppointment: arg }),
  setIsEditingExistingAppointment: (arg: boolean) =>
    set({ isEditingExistingAppointment: arg }),
  setCurrentAppointmentID: (arg: string) => {
    set({ currentAppointmentId: arg });
  },
  setIsCollectingPayment: (arg: boolean) => set({ isCollectingPayment: arg }),
  // todo: get rid of this after refactor to handle nav better
  setIsComingFromGlobalRoster: (arg: boolean) =>
    set({ isComingFromGlobalRoster: arg }),
  setIsManagingIntake: (arg: boolean) => set({ isManagingIntake: arg }),
  setIsSchedulingBoughtTreatment: (arg: boolean) =>
    set({ isSchedulingBoughtTreatment: arg }),
});
